/**
 * The default ARIA label for next month button in navigation
 */
export var labelNext = function () {
    return 'Go to next month';
};
//# sourceMappingURL=labelNext.js.map